import React from 'react';
import { TruckIcon, ClockIcon, GlobeIcon, PackageIcon, RefreshCwIcon } from 'lucide-react';
import CTAButton from '../components/ui/CTAButton';
const ShippingPage = () => {
  return <div className="bg-gray-50 min-h-screen" data-id="element-839">
      {/* Header */}
      <section className="bg-blue-600 text-white py-12" data-id="element-840">
        <div className="container mx-auto px-4" data-id="element-841">
          <h1 className="text-3xl font-bold mb-4" data-id="element-842">Shipping & Returns</h1>
          <p className="text-xl max-w-2xl" data-id="element-843">
            Everything you need to know about our shipping policies, delivery
            times, and hassle-free returns.
          </p>
        </div>
      </section>
      {/* Shipping Info Cards */}
      <section className="py-12" data-id="element-844">
        <div className="container mx-auto px-4" data-id="element-845">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-846">
            <div className="bg-white p-8 rounded-xl shadow-sm text-center" data-id="element-847">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-848">
                <TruckIcon className="h-8 w-8 text-blue-600" data-id="element-849" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-850">Fast Delivery</h3>
              <p className="text-gray-600" data-id="element-851">
                Most domestic orders are delivered within 3-7 business days,
                with express shipping options available.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm text-center" data-id="element-852">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-853">
                <GlobeIcon className="h-8 w-8 text-blue-600" data-id="element-854" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-855">Global Shipping</h3>
              <p className="text-gray-600" data-id="element-856">
                We ship to over 100 countries worldwide with transparent pricing
                and delivery estimates.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm text-center" data-id="element-857">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-858">
                <RefreshCwIcon className="h-8 w-8 text-blue-600" data-id="element-859" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-860">Easy Returns</h3>
              <p className="text-gray-600" data-id="element-861">
                Not satisfied? Return items within 30 days for a full refund
                with our hassle-free return policy.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Shipping Policy */}
      <section className="py-12 bg-white" data-id="element-862">
        <div className="container mx-auto px-4" data-id="element-863">
          <div className="max-w-4xl mx-auto" data-id="element-864">
            <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-865">
              Shipping Policy
            </h2>
            <div className="space-y-8" data-id="element-866">
              <div data-id="element-867">
                <h3 className="text-xl font-semibold mb-3 flex items-center" data-id="element-868">
                  <TruckIcon className="h-5 w-5 mr-2 text-blue-600" data-id="element-869" />
                  Shipping Methods & Timeframes
                </h3>
                <div className="bg-gray-50 rounded-lg p-6" data-id="element-870">
                  <p className="text-gray-700 mb-4" data-id="element-871">
                    MarketHub works with various shipping carriers to ensure
                    your orders are delivered promptly and safely. Shipping
                    methods and delivery times vary by seller, product, and
                    destination.
                  </p>
                  <div className="border-t border-gray-200 pt-4 mt-4" data-id="element-872">
                    <h4 className="font-medium mb-2" data-id="element-873">
                      Domestic Shipping (United States)
                    </h4>
                    <ul className="list-disc pl-5 space-y-2 text-gray-600" data-id="element-874">
                      <li data-id="element-875">Standard Shipping: 3-7 business days</li>
                      <li data-id="element-876">Expedited Shipping: 2-3 business days</li>
                      <li data-id="element-877">Express Shipping: 1-2 business days</li>
                    </ul>
                  </div>
                  <div className="border-t border-gray-200 pt-4 mt-4" data-id="element-878">
                    <h4 className="font-medium mb-2" data-id="element-879">International Shipping</h4>
                    <ul className="list-disc pl-5 space-y-2 text-gray-600" data-id="element-880">
                      <li data-id="element-881">Standard International: 7-21 business days</li>
                      <li data-id="element-882">Expedited International: 5-10 business days</li>
                      <li data-id="element-883">
                        International delivery times may be affected by customs
                        processing
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div data-id="element-884">
                <h3 className="text-xl font-semibold mb-3 flex items-center" data-id="element-885">
                  <PackageIcon className="h-5 w-5 mr-2 text-blue-600" data-id="element-886" />
                  Shipping Costs
                </h3>
                <div className="bg-gray-50 rounded-lg p-6" data-id="element-887">
                  <p className="text-gray-700 mb-4" data-id="element-888">
                    Shipping costs are calculated based on the item's size,
                    weight, shipping destination, and the seller's location. The
                    exact shipping cost will be displayed during checkout before
                    you complete your purchase.
                  </p>
                  <div className="border-t border-gray-200 pt-4 mt-4" data-id="element-889">
                    <h4 className="font-medium mb-2" data-id="element-890">Free Shipping</h4>
                    <p className="text-gray-600" data-id="element-891">
                      Many sellers offer free shipping on orders above a certain
                      amount. Look for the "Free Shipping" badge on product
                      listings.
                    </p>
                  </div>
                  <div className="border-t border-gray-200 pt-4 mt-4" data-id="element-892">
                    <h4 className="font-medium mb-2" data-id="element-893">
                      International Shipping Fees
                    </h4>
                    <p className="text-gray-600" data-id="element-894">
                      International orders may be subject to additional customs
                      duties, taxes, and fees that are not included in the
                      product price or shipping cost. These charges are the
                      buyer's responsibility and are collected by the relevant
                      customs authority.
                    </p>
                  </div>
                </div>
              </div>
              <div data-id="element-895">
                <h3 className="text-xl font-semibold mb-3 flex items-center" data-id="element-896">
                  <ClockIcon className="h-5 w-5 mr-2 text-blue-600" data-id="element-897" />
                  Order Processing
                </h3>
                <div className="bg-gray-50 rounded-lg p-6" data-id="element-898">
                  <p className="text-gray-700 mb-4" data-id="element-899">
                    Most orders are processed within 1-2 business days after
                    payment confirmation. During high-volume periods like
                    holidays, processing times may be slightly longer.
                  </p>
                  <div className="border-t border-gray-200 pt-4 mt-4" data-id="element-900">
                    <h4 className="font-medium mb-2" data-id="element-901">Order Tracking</h4>
                    <p className="text-gray-600" data-id="element-902">
                      Once your order ships, you'll receive a shipping
                      confirmation email with tracking information. You can also
                      track your order through the "My Orders" section of your
                      account.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Returns Policy */}
      <section className="py-12 bg-gray-50" data-id="element-903">
        <div className="container mx-auto px-4" data-id="element-904">
          <div className="max-w-4xl mx-auto" data-id="element-905">
            <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-906">
              Returns & Refunds
            </h2>
            <div className="bg-white rounded-xl shadow-sm p-8" data-id="element-907">
              <p className="text-gray-700 mb-6" data-id="element-908">
                We want you to be completely satisfied with your purchase. If
                for any reason you're not happy with your order, we offer a
                simple and hassle-free return process.
              </p>
              <div className="space-y-6" data-id="element-909">
                <div data-id="element-910">
                  <h3 className="text-lg font-semibold mb-2" data-id="element-911">
                    Return Eligibility
                  </h3>
                  <ul className="list-disc pl-5 space-y-1 text-gray-600" data-id="element-912">
                    <li data-id="element-913">Items must be returned within 30 days of delivery</li>
                    <li data-id="element-914">
                      Products must be unused, unworn, and in their original
                      packaging
                    </li>
                    <li data-id="element-915">
                      Items marked as "Final Sale" or "Non-Returnable" cannot be
                      returned
                    </li>
                    <li data-id="element-916">
                      Custom or personalized items are generally not eligible
                      for return unless defective
                    </li>
                  </ul>
                </div>
                <div data-id="element-917">
                  <h3 className="text-lg font-semibold mb-2" data-id="element-918">
                    How to Return an Item
                  </h3>
                  <ol className="list-decimal pl-5 space-y-2 text-gray-600" data-id="element-919">
                    <li data-id="element-920">Log in to your account and go to "My Orders"</li>
                    <li data-id="element-921">
                      Find the order containing the item you wish to return
                    </li>
                    <li data-id="element-922">Click "Return Item" and follow the instructions</li>
                    <li data-id="element-923">
                      Print the return label (if provided) and securely package
                      the item
                    </li>
                    <li data-id="element-924">
                      Drop off the package at the designated shipping carrier
                    </li>
                  </ol>
                </div>
                <div data-id="element-925">
                  <h3 className="text-lg font-semibold mb-2" data-id="element-926">Refund Process</h3>
                  <p className="text-gray-600" data-id="element-927">
                    Once we receive your return, we'll inspect the item and
                    process your refund. Refunds are issued to your original
                    payment method within 5-7 business days. Please note that
                    shipping costs are generally non-refundable unless the
                    return is due to our error or a defective product.
                  </p>
                </div>
                <div data-id="element-928">
                  <h3 className="text-lg font-semibold mb-2" data-id="element-929">Exchanges</h3>
                  <p className="text-gray-600" data-id="element-930">
                    We currently do not process direct exchanges. If you'd like
                    a different size, color, or item, please return your
                    original purchase for a refund and place a new order for the
                    desired item.
                  </p>
                </div>
                <div data-id="element-931">
                  <h3 className="text-lg font-semibold mb-2" data-id="element-932">
                    Damaged or Incorrect Items
                  </h3>
                  <p className="text-gray-600" data-id="element-933">
                    If you receive a damaged or incorrect item, please contact
                    our customer service team within 48 hours of delivery.
                    Please include photos of the damaged item or packaging to
                    help us resolve the issue quickly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-12 bg-blue-600 text-white" data-id="element-934">
        <div className="container mx-auto px-4 text-center" data-id="element-935">
          <h2 className="text-3xl font-bold mb-4" data-id="element-936">Have Questions?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-937">
            Our customer support team is here to help with any shipping or
            return questions you may have.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-938">
            <CTAButton to="/contact" text="Contact Support" variant="secondary" size="lg" data-id="element-939" />
            <CTAButton to="/faq" text="View FAQ" variant="outline" size="lg" data-id="element-940" />
          </div>
        </div>
      </section>
    </div>;
};
export default ShippingPage;